export type State = {
    admin: boolean;
    tester: boolean;
    blockCreator: boolean;
};
export const state: State = {
    admin: false,
    tester: false,
    blockCreator: false,
};
